import axios from "axios";
import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import Select, {createFilter} from "react-select";
import {useTable} from "react-table";
import moment from "moment";
import {getTerminalErrorInfoApi} from "../Api";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";

function Errors(props) {
  const [terminalSelectData, setTerminalSelectData] = useState([]);
  const [selectedTerminal, setSelectedTerminal] = useState();
  const [data, setData] = useState([]);
  const history = useHistory();
  const location = useLocation();
  const [afterDate, setAfterDate] = useState();
  const [beforeDate, setBeforeDate] = useState();
  const [errorStatusOptions, setErrorStatusOptions] = useState();
  const [error, setError] = useState();
  const columns = [
    {
      Header: "Device",
      accessor: "device",
    },
    {
      Header: "Error",
      accessor: "errorCode",
    },
    {
      Header: "Error Text",
      accessor: "errorText",
    },
    { Header: "Start Time", accessor: "startTime" },
    { Header: "Resolved Time", accessor: "resolveTime" },
    { Header: "Resolved Text", accessor: "" },
    {
      Header: "Option",
      accessor: "lastReplenish",
    },
  ];

  function Table({ columns, data }) {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
      useTable({
        columns,
        data,
      });

    return (
      <>
        <div className="report_table_outer">
          <div className="table-responsive">
            <table {...getTableProps()} className="table table-bordered  small">
              <thead className="thead-light">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }

  const handleTerminalSelectClick = (e) => {
    history.push({
      pathname: "/termManagement/terMinalDetails",
      search: `terminalID=${selectedTerminal.value}`,
    });
  };

  useEffect(() => {
    props?.terminalsData?.map((item, index) => {
      setTerminalSelectData((options) => [
        ...options,
        { label: item.terminalID, value: item.terminalID },
      ]);
    });
    const terminalId = location?.search?.split("=")?.[1];
    setSelectedTerminal({ label: terminalId, value: terminalId });
    setErrorStatusOptions([
      { label: "All", value: "AL" },
      { label: "Resolved", value: "Resolved" },
        { label: "Activity", value: "ACT" },
    ]);
      setError({ label: "All", value: "AL" });
    return () => {
      setData([]);
      setTerminalSelectData([]);
    };
  }, [location]);
  const  reportAfter = moment().format('YYYY-MM-DD');
    const  reportBefore = moment().add(1, "year").format('YYYY-MM-DD');
  const handleSearch = async () => {
      if(typeof afterDate === 'undefined'){
          if(typeof reportAfter !== 'undefined'){  setAfterDate(reportAfter)}else { alert("Please provide Reported After Date");return false};
      }else if(typeof beforeDate === 'undefined'){
          if(typeof reportBefore !== 'undefined'){  setBeforeDate(reportBefore)}else { alert("Please provide Reported Before Date");return false};
      }

    try {
      const result = await axios.get(
        `${getTerminalErrorInfoApi}?paramTerminalID=${selectedTerminal.value}&pStatus=${error.value}&pStartDate=${afterDate}&pEndDate=${beforeDate}&CurrentPage=1`
      );
       setData(result?.data?.response);
    } catch (error) {}
  };
  return (
    <div>
      <div className="row mt-3">
        <div className="col col-md-5">
          <div className="d-flex justify-content-between">
            <label>Reported After:</label>
            <div>
              <input
                type="date" value={reportAfter}
                class="form-control"
                style={{ width: "12.5vw" }}
                onChange={(e) =>
                  setAfterDate(e.target.value + " " + "00:00:00")
                }
              />
            </div>
          </div>
        </div>
        <div className="col col-md-1"></div>
        <div className="col col-md-5">
          <div className="d-flex justify-content-between">
            <label>Resolved Before:</label>
            <div>
              <input
                type="date" value={reportBefore}
                class="form-control"
                style={{ width: "12.5vw" }}
                onChange={(e) =>
                  setBeforeDate(e.target.value + " " + "00:00:00")
                }
              />
            </div>
          </div>
        </div>
      </div>
      {/*  */}
      <div className="row mt-3">
        <div className="col col-md-5">
          <div className="d-flex justify-content-between align-items-center">
            <label>Terminal ID:</label>
            <div>
              <Select
                options={terminalSelectData}
                value={selectedTerminal}
                onChange={(e) => setSelectedTerminal(e)}
                filterOption={createFilter({ ignoreAccents: false })}
                captureMenuScroll={false}
                classNamePrefix="custom-select"
                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    flex: 1,
                    width: "12.5vw",
                  }),
                }}
              />
            </div>
          </div>
        </div>
        <div className="col col-md-1"></div>
        <div className="col col-md-5">
          <div className="d-flex justify-content-between ">
            <label>Error Status:</label>
            <div>
              <Select
                options={errorStatusOptions}
                value={error}
                onChange={(e) => setError(e)}
                filterOption={createFilter({ ignoreAccents: false })}
                captureMenuScroll={false}
                classNamePrefix="custom-select"
                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                styles={{
                  container: (provided) => ({
                    ...provided,
                    flex: 1,
                    width: "12.5vw",
                  }),
                }}
              />
            </div>
          </div>
        </div>
      </div>
      {/*  */}
      <div className="row d-flex justify-content-center mt-2align-items-center">
        <span class="input-group-text" role="button" onClick={handleSearch}>
          Search
        </span>
      </div>
      <hr />
      {/*  */}
      <div className="mt-4">
        {data.length > 0 ? <Table columns={columns} data={data} /> : ""}
      </div>
    </div>
  );
}

export default Errors;
